<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="blue">chat</v-icon>
      大事记
      <v-spacer/>
      <v-btn flat round color="primary" dark
             :disabled="!funcIds.includes('c_proj_event')"
             @click.native.stop="
             () => {
                  editDbid = null;
                  projectId = project? project.dbid: null;
                  edit = true;
                }">
        <v-icon>add</v-icon>
        新增大事记
      </v-btn>
    </v-card-title>

    <v-divider color="blue" />

    <v-card-text class="pt-0">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-0 dense"
        no-data-text="没有数据。"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1}}</td>
          <td>{{ props.item.summary.substring(0, 60) }}{{ props.item.summary.length > 60 ? '...': ''}}</td>
          <td>{{ props.item.userName }}<br/>{{ props.item.timestamp | timestamp }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     @click="
                         () => {
                            viewDbid = props.item.dbid; view = true;
                         }">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>查看</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!funcIds.includes('u_proj_event')"
                     @click="
                      () => {
                        editDbid = props.item.dbid;
                        projectId = project? project.dbid: null;
                        edit = true;
                      }">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <span>编辑</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!funcIds.includes('d_proj_event')"
                     @click="
                     () => {
                        deleDbid = props.item.dbid;
                        deleMsg = `${props.item.summary.substring(0, 20)}${props.item.summary.length > 20 ? '...': ''}`;
                        dele = true;
                     }">
                <v-icon color="pink">delete_forever</v-icon>
              </v-btn>
              <span>删除</span>
            </v-tooltip>
          </td>

        </template>
      </v-data-table>

    </v-card-text>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      :project-id=projectId
      v-on:ok="onEditOk"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XEdit from './Edit'
  import XView from './View'

  import XDelete from '@/components/global/Delete'

  const baseURI = '/api/proj/event';

  export default {
    components: {XEdit, XDelete, XView},

    props: {
      project: Object
    },

    data: () => ({
      uri: baseURI,
      headers: [
        {
          text: '#',
          sortable: false,
          value: 'dbid',
          width: '20'
        },
        {text: '内容', value: 'name', sortable: false},
        {text: '记录人 / 时间', value: 'timestamp', sortable: false, width: 120},
        {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 60}

      ],

      items: [],

      view: false,
      viewDbid: null,

      edit: false,
      editDbid: null,
      projectId: null,

      dele: false,
      deleDbid: null,
      deleMsg: null,

    }),

    computed: {
      ...mapGetters(['funcIds'])
    },

    watch: {
      project(p) {
        this.axios
          .get(`${baseURI}?projectId=${p.dbid}`)
          .then(rsp => this.items = rsp.data.items)
      }
    },

    methods: {
      onEditOk(item) {
        //console.log("in Income onEditOK");
        if (item) {
          if (!this.editDbid) {
            this.items.unshift(item);
          } else {
            const editIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
            this.items[editIdx] = window.xutil.clone(item);
          }
          this.items = this.items.sort((a, b) => a.rank >= b.rank);
        }
      },
      onDeleOk(item) {
        if (item) {
          const deleIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
          this.items.splice(deleIdx, 1);
        }
      }
    }
  }
</script>
